import axios from "axios";

const BASE_URL = "https://sms.brightechsoftware.com/api/v1/sms-template";

export const getTemplates = () => axios.get(BASE_URL);

export const createTemplate = (data) => axios.post(BASE_URL, data);

export const updateTemplate = (id, data) =>
    axios.put(`${BASE_URL}/${id}`, data);

export const deleteTemplate = (id) =>
    axios.delete(`${BASE_URL}/${id}`);